export enum SchemaCodeSnippetIdEnum {
  ARTICLE = 'articleSchemaScript',
  FAQ = 'faqSchemaScript',
  MEDICAL_CLINIC = 'medicalClinicSchemaScript',
  MEDICAL_SERVICE = 'medicalServiceSchemaScript',
  MEDICAL_WEBPAGE = 'medicalWebPageSchemaScript',
}
